var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-color-picker__wrapper"},[_c('p',{staticClass:"x-color-picker__title"},[_vm._v("标准色")]),_c('ul',{staticClass:"x-color-picker__children"},_vm._l((_vm.colors),function(color,i){return _c('li',{key:i,staticClass:"x-color-picker__children-item",style:({
        width: ((_vm.colorRoot.colorBlockSize) + "px"),
        backgroundColor: color
      }),on:{"click":function($event){$event.stopPropagation();return _vm.__confirm(color)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }